import { setActualDate } from '@/helpers/store/setActualDate'
import { filterOnActualDate } from '@/helpers/store/filterOnActualDate'
import { filterBySelectedDomain } from '@/helpers/store/filterBySelectedDomain'
import requestHelper from '@/helpers/store/requestHelper'
import { i18n } from '@/lang'

function rebuildData(state) {
  state.data = state.data.map(domainEntry => {
    const geodynamic = state._geodynamicRaw[domainEntry.domainName] || {}
    const existingDates = new Set(domainEntry.data?.map(d => d.date) || [])

    const dynamicEntries = Object.entries(geodynamic)
      .filter(([date]) => !existingDates.has(date))
      .map(([date, geoData]) => ({ data: geoData, date }))

    return {
      domainName: domainEntry.domainName,
      data: [...(domainEntry.data || []), ...dynamicEntries]
        .sort((a, b) => a.date.localeCompare(b.date)),
    }
  })
  state.actualDate = setActualDate(state.data)
}

export const geo = {
  namespaced: true,
  actions: {
    async load(ctx) {
      await requestHelper(
        {
          url: '/data/getAdditionalGeo',
          viewId: ctx.rootState.view.viewId,
        },
        ctx,
        'storeGeodynamic'
      )
    },
    set(ctx, data) {
      const domain_first = this.getters.domains[0]
      if (domain_first) ctx.commit('updateGeoFirstPickedSite', domain_first)
      const domain_second = this.getters.domains[1]
      if (domain_second) ctx.commit('updateGeoSecondPickedSite', domain_second)
      ctx.commit('updateData', data)
      ctx.commit('updateActualDate')
    },
  },
  state: {
    data: [],
    dataAll: [],
    _geodynamicRaw: {},
    actualDate: null,
    platforms: 'desktop',
    geoFirstPickedSite: '',
    geoSecondPickedSite: '',
    loading: true,
    error: { status: false },
  },
  mutations: {
    updateData(state, data) {
      state.data = data.map(dataItem => ({
        domainName: dataItem.domainName,
        data: dataItem.geo,
      }))
      // If geodynamic already loaded, merge it in
      if (Object.keys(state._geodynamicRaw).length > 0) {
        rebuildData(state)
      }
    },
    storeGeodynamic(state, data) {
      // Store raw geodynamic data keyed by domain
      data.forEach(item => {
        state._geodynamicRaw[item.domainName] = item.data || {}
      })
      // If mainData geo already loaded, merge; otherwise build from geodynamic alone
      if (state.data.length > 0) {
        rebuildData(state)
      } else {
        // mainData hasn't loaded yet — build data from geodynamic only
        state.data = data.map(item => {
          const geodynamic = item.data || {}
          return {
            domainName: item.domainName,
            data: Object.entries(geodynamic)
              .sort(([a], [b]) => a.localeCompare(b))
              .map(([date, geoData]) => ({ data: geoData, date })),
          }
        })
        state.actualDate = setActualDate(state.data)
      }
    },
    updateDataAll(state, data) {
      state.dataAll = data.map(dataItem => ({
        domainName: dataItem.domainName,
        data: dataItem.data,
      }))
    },
    updateGeoFirstPickedSite(state, data) {
      state.geoFirstPickedSite = data
    },
    updateGeoSecondPickedSite(state, data) {
      if (data) state.geoSecondPickedSite = data
    },
    updateActualDate(state, value) {
      state.actualDate = setActualDate(state.data, value)
    },
    updateLoading(state, status) {
      state.loading = status
    },
    updateError(state, data) {
      state.error = data
    },
  },
  getters: {
    dataOnActualDate(state, getters, rootState, rootGetters) {
      return filterOnActualDate(state.data, state.actualDate)
    },
    dataset(state, getters, rootState, rootGetters) {
      const result = {}
      state.data.forEach((dataItem, index) => {
        const data = getters.dataOnActualDate[index]?.data[0]?.data || {}
        result[dataItem.domainName] = data
      })
      return result
    },
    tableData(state, getters, rootState, rootGetters) {
      const items = []
      const fields = [
        {
          key: 'country',
          label: i18n.global.t('analytics.country.title'),
          sortable: true,
        },
        {
          key: 'traffic',
          label: i18n.global.t('analytics.traffic.title'),
          sortable: true,
        },
      ]
      const dataAll = filterBySelectedDomain(
        state.dataAll,
        rootGetters.selectedDomain
      )
      const countriesAll = dataAll[0]?.data || {}
      Object.keys(countriesAll).map(item => {
        items.push({
          country: item,
          traffic: countriesAll[item]?.share,
          change: countriesAll[item]?.change || null,
        })
      })
      return {
        items,
        fields,
      }
    },
    isData(state, getters, rootState) {
      return !rootState.mainData.loading && !rootState.mainData.error.status
    },
  },
}
